export default "__VITE_ASSET__Do9ZqRt0__"